<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
        <p class="page-title">Esqueci a senha</p>
        <div class="dropup-menu">
          <ion-item class="form-item mb-3 mt-0" lines="none">
            <input type="email" placeholder="Email" @input="email = $event.target.value" />
          </ion-item>
          <ion-button
            class="main-button-sm"
            expand="block"
            mode="ios"
            shape="round"
            @click="sendResetPasswordEmail"
          >Enviar link de redefinição</ion-button>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// firebase
import firebase from "firebase";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// component
export default {
  name: "ForgotPassword",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: false,
      fullPage: true,
      email: null
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.go(-1);
    },
    sendResetPasswordEmail() {
      const instance = this;
      instance.startLoading();
      const email = instance.email;
      if (email) {
        firebase
          .auth()
          .sendPasswordResetEmail(email)
          .then(function() {
            instance.isLoading = false;
            instance.notification = {
              class: "error-message p-3",
              message: `Email enviado para ${email}.`
            };
            setTimeout(() => {
              instance.clearNotification();
            }, 3000);
            instance.$router.push({
              name: "Login"
            });
          })
          .catch(function(error) {
            instance.isLoading = false;
            instance.notification = {
              class: "error-message p-3",
              message:
                "Ocorreu um erro ao processar essa operação. Tente novamente."
            };
            setTimeout(() => {
              instance.clearNotification();
            }, 3000);
          });
      } else {
        instance.isLoading = false;
        instance.notification = {
          class: "error-message p-3",
          message: "Por favor, insira todas as informações necessárias."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
      }
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: linear-gradient(
    180deg,
    var(--ion-color-primary),
    var(--bg-color-light)
  ) !important;
}
ion-item {
  --padding-start: 10vw;
  --padding-end: 10vw;
}
</style>
